import { serialize } from 'utils/utils';
import { CALL_API } from '../middleware/api';

export const TYPES = {
  DIMENSIONS_AVAILABILITY_REQUEST: 'DIMENSIONS_AVAILABILITY_REQUEST',
  DIMENSIONS_AVAILABILITY_SUCCESS: 'DIMENSIONS_AVAILABILITY_SUCCESS',
  DIMENSIONS_AVAILABILITY_FAILURE: 'DIMENSIONS_AVAILABILITY_FAILURE',
};

export const loadDimensionsAvailability = params => ({
  [CALL_API]: {
    types: [
      TYPES.DIMENSIONS_AVAILABILITY_REQUEST,
      TYPES.DIMENSIONS_AVAILABILITY_SUCCESS,
      TYPES.DIMENSIONS_AVAILABILITY_FAILURE,
    ],
    endpoint: `/bridge/dimensions/availability?${serialize(params)}`,
  },
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/dimensionsAvailabilityActions.js
 **/